import { styled } from "styled-components";
import { motion } from "framer-motion";

export const Banner = styled(motion.div)
  `position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) !important;
  width: clamp(300px, 90%, 800px);
  background: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #333;
  z-index: 1000;

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }`
;

export const Link = styled.a
  `color: #2563eb;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: #1d4ed8;
  }`
;

export const Button = styled.button
  `padding: 6px 14px;
  background-color: #2563eb;
  border: none;
  border-radius: 6px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s ease;
  font-family: "IBM Plex Sans",sans-serif;
  font-size: 14px;

  &:hover {
    background-color: #1d4ed8;
  }`
;
